import { useContext, useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../Context/ConfigContext";
import { OverlayLoader, ShimmerTableRows } from "../../Components/Shimmers";
import slugify from "slugify";
import { Helmet } from "react-helmet";
import CarInfoBox from "../Cars/CarInfoBox";
import axios from "axios";
import { toast } from 'react-toastify';
import { AddToCartNotifier } from "../../Components/CartComponents";
import NotAssignBrand from "../../Components/NotAssignBrand";
import { CartsContext } from "../../Context/CartsContext";
import "../../styles/Pagination.css"
import { UseRewardsPoints } from "../../Components/GlobalFunctions";
import { axiosGet } from "../../Apis/axiosMethods";
import { default_image } from "../../Imgaes";

const ByBrands = () => {
  const {
    apiURL,
    apiB2BURL,
    setIsCartDropdownOpen,
    business_delivery_days,
    FavItems,
    apiHeaderJson,
    business_type,
    business_id,
    currency
  } = useContext(ConfigContext);

  const {
    AddToCart,
    GetCartItemQty,
    AddToFavorite,
    RemoveToFavorite,
    GetStockPolicyItem
  } = useContext(CartsContext);

  const location = useLocation();
  const { t } = useTranslation();
  const { brand } = useParams();
  const isAddingRef = useRef(false);

  const shop_brand = brand.split('-');

  const sup_id = shop_brand[0];

  // beech ka sab join karo
  const brand_name = decodeURIComponent(
    shop_brand.slice(1, shop_brand.length - 1).join('-')
  );

  const [checkLoading, setCheckLoading] = useState(true);
  const [loading, setLoading] = useState(true);

  const [addToCartLoading, setAddToCartLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const pageFromUrl = Number(searchParams.get("page")) || 1;
  const limitFromUrl = Number(searchParams.get("limit")) || 50;


  const [page, setPage] = useState(pageFromUrl);
  const [limit, setLimit] = useState(limitFromUrl);

  useEffect(() => {
    setSearchParams(prev => {
      const params = new URLSearchParams(prev);
      params.set("page", page);
      params.set("limit", limit);
      return params;
    }, { replace: true });
  }, [page, limit]);


  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const [parts, setParts] = useState([]);
  const [TotalParts, setTotalParts] = useState(0);
  const [TotalPages, setTotalPages] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [oeKeyword, setOeKeyword] = useState("");
  const [expandedOEIndexes, setExpandedOEIndexes] = useState({});

  const [isAssignBrand, setIsAssignBrand] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const navigate = useNavigate();

  const GetPaginationData = async () => {
    try {
      // setLoading(true);
      if (localStorage.getItem("pc_id") === null || localStorage.getItem("pc_id") === undefined || localStorage.getItem("pc_id") === "") {
        const response = await axiosGet(`/Parts/GetByBrandsWithoutCarPagination`, {
          sup_id,
          limit,
          page,
          part_number: keyword,
          oe_number: oeKeyword,
          business_type,
          pc_id: localStorage.getItem('pc_id')
        });

        if (response?.data?.success) {
          setTotalParts(response.data.total_records);
          setTotalPages(response.data.total_pages);
        }
      } else {
        const response = await axiosGet(`/Parts/GetByBrandsWithCarPagination`, {
          sup_id,
          limit,
          page,
          part_number: keyword,
          oe_number: oeKeyword,
          business_type,
          pc_id: localStorage.getItem('pc_id')
        });

        if (response?.data?.success) {
          setTotalParts(response?.data?.total_records);
          setTotalPages(response?.data?.total_pages);
        }

      }
    } catch (error) {
      console.log(error)
    } finally {
      // setLoading(false)
    }
  };

  useEffect(() => {
    GetPaginationData()
  }, [isUpdate, page, limit])

  const GetByBrandsWithoutCar = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const response = await axiosGet(`/Parts/${localStorage.getItem('pc_id') ? "GetShopByBrandsWithCar" : "GetShopByBrandsWithoutCar"}`,
        {
          pc_id: localStorage.getItem('pc_id'),
          brand: brand_name,
          brand_name,
          sup_id,
          limit,
          page: pageNumber,
          part_number: keyword,
          oe_number: oeKeyword,
          str_id: selectedDepartment,
          business_type,
          currency
        }
      );

      if (response.data?.success) {
        setParts(response.data.data || []);
        setPage(pageNumber);
      }

      return response.data;

    } catch (error) {
      console.log(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetByBrandsWithoutCar(page);
  }, [isUpdate, page, limit]);

  const CheckBrands = async () => {
    try {
      const response = await axiosGet(`/Parts/CheckAssignBrandsForBusiness`, { business_sup_id: sup_id });

      if (response?.data?.success) {
        setIsAssignBrand(response?.data?.assigned)
        setCheckLoading(false)
      }

    } catch (error) {
      console.log(error);
    } finally {
      setCheckLoading(false)
    }
  }

  useEffect(() => {
    CheckBrands();
  }, [location])

  const getSerialNumber = (index) => {
    return (page - 1) * limit + index + 1;
  };

  const handleAddToCart = async (part, url) => {
    if (isAddingRef.current) return;
    isAddingRef.current = true;

    try {
      setAddToCartLoading(true);

      const prev_qty = Number(await GetCartItemQty(part?.ART_SEARCH_NUMBER));

      const stock = Number(part?.stock_available_qty);

      if (!stock) {
        toast.success(
          <AddToCartNotifier
            item_name={"We dont have stock for this part"}
            item_img={""}
          />
        );
        return;
      }

      // Get Stock Policy
      const stockPolicy = await GetStockPolicyItem(
        part?.ART_SEARCH_NUMBER,
        part?.stock_oe,
        part?.stock_sup_id,
        part?.stock_brand_name
      );

      const minQty = Number(stockPolicy?.policy_min_qty || 1);

      // Default quantity
      let addQty = minQty;

      // Remaining stock after cart quantity
      const remainingStock = stock - prev_qty;

      // If remaining stock is less than min qty, add remaining stock
      if (remainingStock < minQty && remainingStock > 0) {
        addQty = remainingStock;
      }

      if (remainingStock >= addQty) {

        const partImg = part?.MEDIA_SOURCE
          ? part.MEDIA_SOURCE
          : `${apiURL}/public/placeholder_category.jpeg`;

        const item = {
          ART_ID: part?.ART_ID,
          ART_ARTICLE_NR: part?.ART_SEARCH_NUMBER,
          PRODUCT_GROUP_EN: part?.PRODUCT_GROUP_EN,
          stock_price_mrp: part?.stock_price_mrp,
          VD_BB_PRICE: part?.stock_bb_price,
          VD_BG_PRICE: part?.stock_bg_price,
          ART_SUP_ID: part?.stock_sup_id || 0,
          ART_SUP_BRAND: part?.stock_brand_name,
          inventory_store_id: part?.inventory_store_id,
          stock_oe: part?.stock_oe ?? 0,
          VD_QTY: stock,
          stock_delivery_days: part?.stock_delivery_days,
        };

        await AddToCart(item, addQty, partImg, url);

        setIsCartDropdownOpen(true);
        window.scrollTo(0, 0);

      } else {

        toast.success(
          <AddToCartNotifier
            item_name={"We dont have enough stock for this part"}
            item_img={""}
          />
        );

      }

    } catch (error) {
      console.log("handleAddToCart Error:", error);
    } finally {
      setAddToCartLoading(false);
      isAddingRef.current = false;
    }
  };


  const handleAddToFavorite = async (item, url) => {
    try {
      const partImg = item?.MEDIA_SOURCE
        ? `${item?.MEDIA_SOURCE}`
        : `${apiURL}/public/placeholder_category.jpeg`;

      const data = {
        business_id,
        item_id: item.ART_ID,
        item_number: item.ART_ARTICLE_NR.replace(/[^a-zA-Z0-9]/g, ''),
        item_title: item.PRODUCT_GROUP_EN,
        item_sup_id: item?.stock_sup_id,
        item_mrp: item.stock_price_mrp,
        item_price: Number(business_type) === 1 ? item?.stock_bg_price : item?.stock_bb_price,
        item_qty: 1,
        item_img_url: partImg,
        item_url: url,
        max_qty: item.stock_available_qty,
        item_store_id: item?.inventory_store_id,
        item_stock_oe: item?.stock_oe,
        item_delivery_days: item?.stock_delivery_days,
        item_brand_name: item?.stock_brand_name
      };

      await AddToFavorite(data);
    } catch (error) {
      toast.error("Error adding to favorites.");
    }
  };

  const toggleOEExpand = (rowIdx) => {
    setExpandedOEIndexes(prev => ({
      ...prev,
      [rowIdx]: !prev[rowIdx]
    }));
  };

  const handleRemoveToFavorite = async (part) => {
    try {
      await RemoveToFavorite(part);
    } catch (error) {
    }
  }

  const handleSearch = () => {
    if (keyword || oeKeyword || selectedDepartment) {
      setIsUpdate(prev => !prev);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    if (keyword || oeKeyword || selectedDepartment) {
      setKeyword("");
      setOeKeyword("");
      setSelectedDepartment(null);
      setIsUpdate(prev => !prev);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const total = TotalPages;
    const windowSize = 5;

    let start = page;
    let end = page + windowSize - 1;

    // If end exceeds total pages
    if (end > total) {
      end = total;
      start = total - windowSize + 1;
    }

    // If start goes below 1
    if (start < 1) {
      start = 1;
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);

    setLimit(newLimit);
    setPage(1);
    setIsUpdate(prev => !prev);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > TotalPages) return;

    setPage(pageNumber); // ✅ ADD THIS

    const tableTop = document.getElementById("parts-table-top");
    if (tableTop) {
      tableTop.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  return (
    <>
      {loading ? (
        <div style={{ height: "70vh" }}>
          <OverlayLoader />
        </div>
      )
        :
        <div className="header-bottom d-lg-block">
          <Helmet><title>Shop By Brand</title></Helmet>
          <div className="container">
            <CarInfoBox />
            {
              parts.length > 0 &&
              <h4 className="mt-3" id="parts-table-top">
                {brand_name} Part List
                {parts.length > 0 && <small> (Total Parts: {TotalParts ? TotalParts : parts?.length})</small>}
              </h4>
            }


            <div className="row">
              <div className="col-md-4">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("Search by Part Number")}
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("Search by OE Number")}
                    value={oeKeyword}
                    onChange={(e) => setOeKeyword(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <button
                  className="btn btn-primary mr-2"
                  onClick={handleSearch}
                >
                  <i className="fas fa-search"></i> {t("Search")}
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={handleClearSearch}
                >
                  <i className="fas fa-times"></i> {t("Clear")}
                </button>
              </div>
            </div>

            <table className="table table-striped table-bordered table-responsive">
              <thead>
                <tr>
                  <th width="10">SR No.</th>
                  <th style={{ verticalAlign: 'middle' }} width="400">Part Name</th>
                  <th style={{ minWidth: '150px', verticalAlign: 'middle' }}>Part Number</th>
                  <th style={{ verticalAlign: 'middle' }}>Picture</th>
                  <th>Available QTY</th>
                  <th style={{ verticalAlign: 'middle' }}>
                    Offer Price <small style={{ color: "red", fontWeight: "bold" }}>excl. 5.0% VAT</small>
                  </th>

                  <th style={{ verticalAlign: 'middle' }}>OE Numbers</th>
                  {
                    currency.toLowerCase() !== "usd" &&
                    <th style={{ verticalAlign: 'middle' }}>Delivery Days</th>
                  }
                  <th style={{ verticalAlign: 'middle' }}>Details</th>
                  <th style={{ verticalAlign: 'middle' }}>Buy</th>
                  <th style={{ textAlign: 'center' }}>Add To Favorites</th>
                </tr>
              </thead>
              <tbody>
                {loading &&
                  <ShimmerTableRows colspan={12} rows={limit} />
                }

                {!loading && !checkLoading && isAssignBrand === false && (
                  <tr>
                    <td colSpan={9}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <NotAssignBrand />
                      </div>
                    </td>
                  </tr>
                )}

                {!loading && !checkLoading && isAssignBrand === true && parts?.length > 0 && parts?.map((part, index) => {

                  const productSlug = slugify(
                    (part?.PRODUCT_GROUP_EN || "-")
                      .replace(/,/g, "")
                      .toLowerCase()
                  );

                  const url = `/Spare-Parts/Details/${productSlug}-${part.ART_SEARCH_NUMBER}-${part.stock_sup_id}`;

                  var isFavorite = FavItems && FavItems.find(item =>
                    item.item_number === part.ART_SEARCH_NUMBER &&
                    item?.item_brand_name === part?.stock_brand_name
                  );

                  const beforePrice =
                    business_type === 1
                      ? part?.stock_before_bg_price
                      : part?.stock_before_bb_price;

                  const display_price = Number(business_type) === 1 ?
                    Number(part.stock_bg_price).toFixed(2)
                    :
                    Number(part.stock_bb_price).toFixed(2)


                  const get_rewards_points = UseRewardsPoints(display_price);


                  return (
                    <tr key={part.ART_ID}>

                      <td>{getSerialNumber(index)}</td>
                      {/* <td>{serial}</td> */}

                      <td width="20%" style={{ verticalAlign: 'middle' }}>
                        <NavLink to={url}>
                          {part && part.PRODUCT_GROUP_EN}
                        </NavLink>
                      </td>

                      <td width="10%" style={{ verticalAlign: 'middle' }}>
                        <NavLink to={url}>
                          {part.ART_SEARCH_NUMBER}
                        </NavLink>
                      </td>

                      <td>
                        <NavLink to={url}>
                          <img
                            src={`${part.MEDIA_SOURCE ? part.MEDIA_SOURCE : default_image}`}
                            style={{ width: '50px' }}
                            alt={part?.PRODUCT_GROUP_EN}
                          />
                        </NavLink>
                      </td>

                      <td style={{ verticalAlign: 'middle' }}>
                        {part?.stock_available_qty > 0 ? part?.stock_available_qty
                          :
                          <div className="text-center">
                            <span className="badge badge-danger">Out of stock</span>
                          </div>
                        }
                      </td>

                      <td style={{ verticalAlign: "middle" }}>
                        <div>
                          <div
                            className="d-flex align-items-center"
                            style={{
                              gap: "8px",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <span style={{ fontWeight: 600, fontSize: "14px" }}>
                              {part?.display_price}
                            </span>

                            {beforePrice > 0 && beforePrice > display_price && (
                              <small
                                className="text-muted"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Was:{" "}
                                <del>
                                  {beforePrice.toFixed(2)}{currency?.toUpperCase()}
                                </del>
                              </small>
                            )}
                          </div>

                          {
                            currency.toLowerCase() !== "usd" &&
                            <div
                              style={{
                                fontSize: "12px",
                                marginTop: "4px",
                                fontWeight: 500
                              }}
                            >
                              <span style={{ color: "#000" }}>
                                You will get{" "}
                              </span>

                              <span className="text-primary" style={{ fontWeight: 700 }}>
                                {get_rewards_points} rewards points {" "}
                              </span>

                              <span style={{ color: "#000" }}>
                                On This
                              </span>
                            </div>
                          }
                        </div>
                      </td>


                      <td style={{ verticalAlign: 'middle' }}>
                        {(() => {
                          try {
                            const oeNumbers =
                              typeof part.OE_NUMBERS_CROSS === "string"
                                ? JSON.parse(part.OE_NUMBERS_CROSS || "[]")
                                : part.OE_NUMBERS_CROSS || [];

                            const seen = new Set();
                            const uniqueOEs = [];

                            for (const oe of oeNumbers) {
                              if (oe.ARL_DISPLAY_NR && !seen.has(oe.ARL_DISPLAY_NR)) {
                                uniqueOEs.push(oe.ARL_DISPLAY_NR);
                                seen.add(oe.ARL_DISPLAY_NR);
                              }
                            }

                            if (uniqueOEs.length === 0) return <span>-</span>;

                            const isExpanded = expandedOEIndexes[part.ART_ID];
                            if (uniqueOEs.length <= 2 || isExpanded) {
                              return (
                                <>
                                  {uniqueOEs.map((oe, idx) => (
                                    <span key={oe}>
                                      <NavLink
                                        onClick={() => {
                                          window.scrollTo({
                                            top: 0,
                                            behavior: "smooth",
                                          });
                                        }}
                                        to={`/Spare-Parts/OEM/${part.PRODUCT_GROUP_EN?.replace(/[^a-zA-Z0-9\s]/g, '-')}-${oe?.replace(/[^a-zA-Z0-9]/g, '')}`}>
                                        {oe}
                                      </NavLink>
                                      {idx < uniqueOEs.length - 1 ? ', ' : ''}
                                    </span>
                                  ))}
                                  {uniqueOEs.length > 2 && (
                                    <span
                                      style={{
                                        color: "#007bff",
                                        cursor: "pointer",
                                        marginLeft: 4,
                                        fontWeight: 500,
                                        position: "relative"
                                      }}
                                      onClick={() => toggleOEExpand(part.ART_ID)}
                                    >
                                      &nbsp;- less
                                    </span>
                                  )}
                                </>
                              );
                            }
                            return (
                              <>
                                {uniqueOEs.slice(0, 2).map((oe, idx) => (
                                  <span key={oe}>
                                    <NavLink
                                      to={`/Spare-Parts/OEM/${part.PRODUCT_GROUP_EN?.toString()
                                        .trim()
                                        .replace(/,/g, "")
                                        .replace(/\s+/g, "-")}-${oe?.replace(/[^a-zA-Z0-9]/g, '')}`}
                                    >
                                      {oe}
                                    </NavLink>
                                    {idx < 1 ? ', ' : ''}
                                  </span>
                                ))}
                                <span
                                  style={{
                                    color: "#007bff",
                                    cursor: "pointer",
                                    marginLeft: 4,
                                    fontWeight: 500,
                                    position: "relative"
                                  }}
                                  onClick={() => toggleOEExpand(part.ART_ID)}
                                >
                                  +more
                                </span>
                              </>
                            );
                          } catch (error) {
                            console.error("Error parsing OE_NUMBERS_CROSS for part:", part.ART_ID, error);
                            return <span>-</span>;
                          }
                        })()}
                      </td>

                      {
                        currency.toLowerCase() !== "usd" &&
                        <td style={{ verticalAlign: 'middle' }}>
                          {(() => {
                            const total =
                              (part?.stock_delivery_days || 0) +
                              (business_delivery_days || 0);

                            if (total === 0) return "Same Day";

                            return `${total} ${total === 1 ? "Day" : "Days"}`;
                          })()}
                        </td>
                      }

                      <td style={{ verticalAlign: 'middle' }}>
                        <button onClick={() => navigate(url)} className="btn btn-sm btn-info"> <i className="fas fa-info-circle"></i> Details </button>
                      </td>

                      <td style={{ verticalAlign: 'middle' }}>
                        <div className="btn-group" role="group" aria-label="Cart and Favorite">

                          <button
                            className="btn btn-sm btn-dark"
                            type="button"
                            onClick={() => handleAddToCart(part, url)}
                            disabled={
                              addToCartLoading ||
                              isAddingRef.current ||
                              (business_type === 1
                                ? Number(part.stock_bg_price) === 0
                                : Number(part.stock_bb_price) === 0)
                            }
                          >
                            <i className="fas fa-cart-plus"></i> Buy
                          </button>
                        </div>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div onClick={() => {
                          if (isFavorite) {
                            handleRemoveToFavorite(part)
                          } else {
                            handleAddToFavorite(part, url)
                          }
                        }}
                          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                        >
                          <i
                            className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`}
                            style={{ fontSize: '18px' }}
                          >
                          </i>
                          <span style={{ fontSize: '14px', fontWeight: '500', paddingBottom: '2px' }}></span>
                        </div>
                      </td>
                    </tr>
                  );
                })}

                {!loading && !checkLoading && isAssignBrand === true && parts.length === 0 && (
                  <tr>
                    <td colSpan={11}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <div className="noresult" style={{ display: 'block', width: '100%' }}>
                          <div className="text-center">
                            <lord-icon
                              src="https://cdn.lordicon.com/msoeawqm.json"
                              trigger="loop"
                              colors="primary:#121331,secondary:#08a88a"
                              style={{ width: '75px', height: '75px' }} />
                            <h5 className="">Sorry! No Result Found</h5>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>

              {TotalPages > 1 && (
                <tfoot>
                  <tr>
                    <td colSpan={11}>

                      <div className="d-flex justify-content-end align-items-center flex-wrap gap-2">

                        {/* Show entries info */}
                        <div className="show-entries">
                          Showing {(page - 1) * limit + 1} to {Math.min(page * limit, TotalParts)} of {TotalParts} entries
                        </div>

                        {/* Right side controls */}
                        <div className="d-flex align-items-center gap-3">

                          {/* Pagination */}
                          <nav>
                            <ul className="custom-pagination mb-0">
                              <li
                                className={`page-btn ${page === 1 ? "disabled" : ""}`}
                                onClick={() => page > 1 && handlePageChange(1)}
                              >
                                &laquo;
                              </li>

                              {/* Previous */}
                              <li
                                className={`page-btn ${page === 1 ? "disabled" : ""}`}
                                onClick={() => page > 1 && handlePageChange(page - 1)}
                              >
                                &lt;
                              </li>

                              {/* Pages */}
                              {getPageNumbers().map((p, index) => (
                                p === "..." ? (
                                  <li key={`dots-${index}`} className="page-btn dots">...</li>
                                ) : (
                                  <li
                                    key={p}
                                    className={`page-btn ${p === page ? "active" : ""}`}
                                    onClick={() => handlePageChange(p)}
                                  >
                                    {p}
                                  </li>
                                )
                              ))}

                              {/* Next */}
                              <li
                                className={`page-btn ${page === TotalPages ? "disabled" : ""}`}
                                onClick={() => page < TotalPages && handlePageChange(page + 1)}
                              >
                                &gt;
                              </li>

                              <li
                                className={`page-btn ${page === TotalPages ? "disabled" : ""}`}
                                onClick={() => page < TotalPages && handlePageChange(TotalPages)}
                              >
                                &raquo;
                              </li>

                            </ul>
                          </nav>

                          <div className="d-flex align-items-center" style={{ marginLeft: "10px" }}>
                            <select
                              className="form-control form-control-sm"
                              value={limit}
                              onChange={handleLimitChange}
                            >
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                              <option value={150}>150</option>
                              <option value={200}>200</option>
                              <option value={250}>250</option>
                            </select>
                          </div>

                        </div>
                      </div>


                    </td>
                  </tr>
                </tfoot>
              )}

            </table>
          </div>
        </div>
      }
    </>
  );
};

export default ByBrands;